export var EKeyCode;
(function (EKeyCode) {
  EKeyCode[EKeyCode["Backspace"] = 8] = "Backspace";
  EKeyCode[EKeyCode["Enter"] = 13] = "Enter";
})(EKeyCode || (EKeyCode = {}));